import { render, staticRenderFns } from "./GiftDeposit.vue?vue&type=template&id=010a6562&scoped=true"
import script from "./GiftDeposit.vue?vue&type=script&lang=js"
export * from "./GiftDeposit.vue?vue&type=script&lang=js"
import style0 from "./GiftDeposit.vue?vue&type=style&index=0&id=010a6562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a6562",
  null
  
)

export default component.exports